import api from "api/api";

export const createSector = async (data) =>
  await api.post("/settings/sectors", data);

export const deleteSectorById = async (id) =>
  await api.delete(`/settings/sectors/${id}`);

export const getSectorById = async (id) =>
  await api.get(`/settings/sectors/${id}`);

export const getSectorList = async () => await api.get("/settings/sectors");

export const updateSectorById = async (id, data) =>
  await api.put(`/settings/sectors/${id}`, data);
